import { server_endpoint } from "../store";
import axios from "axios";

export const updateProfileAction = formdata => async (dispatch) => {
  try {
    dispatch({
      type: "updateProfileRequest",
    });

    // const userdata = {
    //   name,
    //   email,
    // };

    const { data } = await axios.put(
      `${server_endpoint}/updateprofile`,
      formdata,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    dispatch({
      type: "updateProfileSuccess",
      payload : data.message
    });
  } catch (error) {
    dispatch({
      type: "updateProfileFail",
      payload: error?.response?.data?.message,
    });
  }
};


export const changePasswordAction = (oldpassword, newpassword) => async (dispatch) => {
    try {
      dispatch({
        type: "changePasswordRequest",
      });
  
      const userdata = {
        oldpassword,
        newpassword,
      };
  
      const { data } = await axios.put(
        `${server_endpoint}/user/changepassword`,
        userdata,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      dispatch({
        type: "changePasswordSuccess",
        payload : data.message
      });
    } catch (error) {
      dispatch({
        type: "changePasswordFail",
        payload: error?.response?.data?.message,
      });
    }
  };
  

  export const updateProfilePictureAction = formdata => async (dispatch) => {
    try {
      dispatch({
        type: "updatePictureRequest",
      });
  
    //   const userdata = {
    //     name,
    //     email,
    //   };
  
      const { data } = await axios.put(
        `${server_endpoint}/user/updatepicture`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      dispatch({
        type: "updatePictureSuccess",
        payload : data
      });
    } catch (error) {
      console.log(error)
      dispatch({
        type: "updatePictureFail",
        payload: 'No Picture was selected',
      });
    }
  };
  